// extracted by mini-css-extract-plugin
module.exports = {"root":"GamePreviewText_root_1BkFv","title":"GamePreviewText_title_2IYQL","description":"GamePreviewText_description_1Tpf_"};